"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('service/achievement',['appkit/service', 'marionette', 'jquery', '../config', '../view/achievement'], function (Service, Mn, $, config, AchievementView) {
  var AchievementService = Service.extend(_defineProperty({
    events: {
      'app:start': 'onAppStart'
    },
    replies: {
      'achievement:enable': 'enableAchievement',
      'achievement:unlock': 'unlockAchievement',
      'build:achievements': 'buildAchievements'
    },
    initialize: function initialize() {
      this.enabled = false;
      this.achievementMap = {};
      this.displayedAchievements = new Backbone.Collection();
    },
    buildAchievements: function buildAchievements(options) {
      return new Mn.CollectionView(_.extend({
        childView: AchievementView,
        attributes: {
          style: "position: fixed; right: 0px; bottom: 0px; z-index: 1000; margin: 10px"
        }
      }, options));
    },
    onAppStart: function onAppStart() {
      this.listView = this.buildAchievements({
        collection: this.displayedAchievements
      });
      this.audioTag = $('<audio><source type="audio/mp3" src="' + config.staticRoot + '/resources/sounds/achievement.mp3"></audio>').get(0);
      $(document.body).append(this.listView.$el).append(this.audioTag);
      this.listView.trigger('show');
    },
    isUnlocked: function isUnlocked(name) {
      return !!this.achievementMap[name];
    },
    isEnabled: function isEnabled() {
      return !!this.enabled;
    },
    markAchievement: function markAchievement(name) {
      this.achievementMap[name] = true;
    },
    enableAchievement: function enableAchievement() {
      this.enabled = true;
    },
    unlockAchievement: function unlockAchievement(name) {
      if (this.isEnabled() && !this.isUnlocked(name)) {
        this.markAchievement(name);
        this.displayAchievement(name);
      }
    },
    displayAchievement: function displayAchievement(name) {
      var model = new Backbone.Model({
          header: 'Achievement Unlocked!',
          body: name
        }),
        self = this;
      this.displayedAchievements.add(model);
      this.audioTag.play();
      setTimeout(function () {
        model.trigger('will:remove');
        setTimeout(function () {
          self.displayedAchievements.remove(model);
        }, 1000);
      }, 4000);
    }
  }, "buildAchievements", function buildAchievements(options) {
    return new Mn.CollectionView(_.extend({
      childView: AchievementView,
      attributes: {
        style: "position: fixed; right: 0px; bottom: 0px; z-index: 1000; margin: 10px"
      }
    }, options));
  }));
  return AchievementService;
});

